export const emailManagerConstants = {
   VIEW_OVERVIEW_REQUEST:        'VIEW_OVERVIEW_REQUEST',
   VIEW_OVERVIEW_SUCCESS:        'VIEW_OVERVIEW_SUCCESS',
   VIEW_OVERVIEW_FAILURE:        'VIEW_OVERVIEW_FAILURE',
   GET_COUNTRYCITY_REQUEST:      'GET_COUNTRYCITY_REQUEST',
   GET_COUNTRYCITY_SUCCESS:      'GET_COUNTRYCITY_SUCCESS',
   GET_COUNTRYCITY_FAILURE:      'GET_COUNTRYCITY_FAILURE',
   POST_CREATEEMAIL_REQUEST:     'POST_CREATEEMAIL_REQUEST',
   POST_CREATEEMAIL_SUCCESS:     'POST_CREATEEMAIL_SUCCESS',
   POST_CREATEEMAIL_FAILURE:     'POST_CREATEEMAIL_FAILURE',
   GET_DETAIL_REQUEST: 			   'GET_DETAIL_REQUEST',
   GET_DETAIL_SUCCESS: 			   'GET_DETAIL_SUCCESS',
   GET_DETAIL_FAILURE: 			   'GET_DETAIL_FAILURE',
   EDIT_DETAIL_REQUEST:          'EDIT_DETAIL_REQUEST',
   EDIT_DETAIL_SUCCESS:          'EDIT_DETAIL_SUCCESS',
   EDIT_DETAIL_FAILURE:          'EDIT_DETAIL_FAILURE',
   DELETE_DETAIL_REQUEST:        'DELETE_DETAIL_REQUEST',
   DELETE_DETAIL_SUCCESS:        'DELETE_DETAIL_SUCCESS',
   DELETE_DETAIL_FAILURE:        'DELETE_DETAIL_FAILURE',
   SEND_TESTMAIL_REQUEST:        'SEND_TESTMAIL_REQUEST',
   SEND_TESTMAIL_SUCCESS:        'SEND_TESTMAIL_SUCCESS',
   SEND_TESTMAIL_FAILURE:        'SEND_TESTMAIL_FAILURE',
   GET_DEAL_REQUEST:             'GET_DEAL_REQUEST',
   GET_DEAL_SUCCESS:             'GET_DEAL_SUCCESS',
   GET_DEAL_FAILURE:             'GET_DEAL_FAILURE',
   GET_TEMPLATE_REQUEST:         'GET_TEMPLATE_REQUEST',
   GET_TEMPLATE_SUCCESS:         'GET_TEMPLATE_SUCCESS',
   GET_TEMPLATE_FAILURE:         'GET_TEMPLATE_FAILURE',
   POST_EXPORT_REQUEST:          'POST_EXPORT_REQUEST',
   POST_EXPORT_SUCCESS:          'POST_EXPORT_SUCCESS',
   POST_EXPORT_FAILURE:          'POST_EXPORT_FAILURE',
   POST_IMPORT_REQUEST:          'POST_IMPORT_REQUEST',
   POST_IMPORT_SUCCESS:          'POST_IMPORT_SUCCESS',
   POST_IMPORT_FAILURE:          'POST_IMPORT_FAILURE',
   GET_FILELIST_REQUEST:         'GET_FILELIST_REQUEST',
   GET_FILELIST_SUCCESS:         'GET_FILELIST_SUCCESS',
   GET_FILELIST_FAILURE:         'GET_FILELIST_FAILURE',
   GET_DISABLE_REQUEST:          'GET_DISABLE_REQUEST',
   GET_DISABLE_SUCCESS:          'GET_DISABLE_SUCCESS',
   GET_DISABLE_FAILURE:          'GET_DISABLE_FAILURE',
   GET_TOTAL_REQUEST:            'GET_TOTAL_REQUEST',
   GET_TOTAL_SUCCESS:            'GET_TOTAL_SUCCESS',
   GET_TOTAL_FAILURE:            'GET_TOTAL_FAILURE',
   POST_NOTIFICATION_REQUEST:    'POST_NOTIFICATION_REQUEST',
   POST_NOTIFICATION_SUCCESS:    'POST_NOTIFICATION_SUCCESS',
   POST_NOTIFICATION_FAILURE:    'POST_NOTIFICATION_FAILURE',
   GET_NOTIFICATION_REQUEST:     'GET_NOTIFICATION_REQUEST',
   GET_NOTIFICATION_SUCCESS:     'GET_NOTIFICATION_SUCCESS',
   GET_NOTIFICATION_FAILURE:     'GET_NOTIFICATION_FAILURE',
   POST_VIEWSTATS_REQUEST:       'POST_VIEWSTATS_REQUEST',
   POST_VIEWSTATS_SUCCESS:       'POST_VIEWSTATS_SUCCESS',
   POST_VIEWSTATS_FAILURE:       'POST_VIEWSTATS_FAILURE',
};


// WEBPACK FOOTER //
// ./src/app/redux/constants/emailManagerConstants.js